module.exports = __webpack_public_path__ + "img/bg-valid-mail.jpg";